export default __webpack_public_path__ + "static/media/CR.4f4950b2.svg";